// Bloqueo exclusivo de escritura por contacto asignado. Se aplica salvo que el
// customer permita explícitamente la interacción multi-agente.
const isLockEnabled = (agent) => agent?.agents_interact_with_assigned_contacts !== true;

const contactById = (state, id_contact) => {
    const { contact = {}, assignedContact = {} } = state || {};
    if (contact.contactDetails?._id === id_contact) return contact.contactDetails;
    return (
        contact.contactsChats?.find((c) => c._id === id_contact) ||
        contact.contacts?.find((c) => c._id === id_contact) ||
        assignedContact.contactsAssigneds
            ?.flatMap((a) => a.contacts || [])
            .find((c) => c._id === id_contact) ||
        null
    );
};

// locked = lock habilitado && contacto con agente asignado && ese agente no soy yo
export const isContactWriteLocked = (state, id_contact) => {
    if (!id_contact) return false;

    const contact = contactById(state, id_contact);
    if (!contact || !isLockEnabled(state?.agent)) return false;

    const assigned = contact.id_agent ?? null;
    if (assigned == null) return false;

    return String(assigned) !== String(state?.agent?._id);
};
